import { Message } from "element-ui";
import { BimTrafficSimulationNodeList } from "@/api/api";
import Vue from "@/main";
export let graphicLayer = null;

export function handleTrafficSimulation(type, id) {
  let modelData = {
    ProjectId: window.sessionStorage.getItem("nowProjectId"),
    dataType: 2,
  };
  BimTrafficSimulationNodeList(modelData)
    .then((res) => {
      if (res.data.code == 200 || res.data.code == 204) {
        res.data.data.forEach((el) => {
          if (el.id == id) {
            openSimulation(el);
          }
        });
      } else {
        Message({
          message: "请求失败，请稍后再试",
          type: "error",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    })
    .catch((err) => {
      Message({
        message: "请求失败，请稍后再试",
        type: "error",
        offset: 100,
        showClose: true,
        duration: 1600,
      });
    });
}

function openSimulation(e) {
  showCar(e.czmlUrl);
}

export function showCar(url) {
  removeLayer();
  graphicLayer = new mars3d.layer.CzmlLayer({
    name: "",
    url: process.env.VUE_APP_LOCAL_RESOURCES_PATH + "/" + url,
    // flyTo: true,
  });
  Vue.$GLOBAL.map.addLayer(graphicLayer);
}

export function removeLayer() {
  if (graphicLayer) {
    Vue.$GLOBAL.map.removeLayer(graphicLayer, true);
    graphicLayer = null;
  }
}
